import Icon from '../components/Icon.vue'

Icon.register({
  'sd-card': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M320 0H128L0 128V448C0 483.3 28.7 512 64 512H320C355.3 512 384 483.3 384 448V64C384 28.7 355.3 0 320 0zM160 160H112V64H160V160zM240 160H192V64H240V160zM320 160H272V64H320V160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sd-card.js
// module id = 79C4
// module chunks = 144